// teamColors.js

// Color palette with 20 bright, vibrant, and truly distinct colors
export const predefinedColors = [
    '#FF1493', // Deep Pink
    '#00FF00', // Lime
    '#1E90FF', // Dodger Blue
    '#FFD700', // Gold
    '#FF4500', // Orange Red
    '#00FFFF', // Aqua
    '#FF00FF', // Fuchsia
    '#32CD32', // Lime Green
    '#8A2BE2', // Blue Violet
    '#FFA500', // Orange
    '#9400D3', // Dark Violet
    '#00CED1', // Dark Turquoise
    '#FF6347', // Tomato
    '#ADFF2F', // Green Yellow
    '#FF69B4', // Hot Pink
    '#20B2AA', // Light Sea Green
    '#DAA520', // Goldenrod
    '#FF6B6B', // Light Coral
    '#7FFF00', // Chartreuse
    '#FF4500'  // Red Orange (Repeated)
];

export const getTeamColor = (teamIndex) => {
    return predefinedColors[teamIndex % predefinedColors.length];
};

// Helper function to get color name
export const getColorName = (colorHex) => {
    const colorNames = [
        'Deep Pink', 'Lime', 'Dodger Blue', 'Gold', 'Orange Red',
        'Aqua', 'Fuchsia', 'Lime Green', 'Blue Violet', 'Orange',
        'Dark Violet', 'Dark Turquoise', 'Tomato', 'Green Yellow', 'Hot Pink',
        'Light Sea Green', 'Goldenrod', 'Light Coral', 'Chartreuse', 'Red Orange'
    ];
    const index = predefinedColors.indexOf(colorHex.toUpperCase());
    return index !== -1 ? colorNames[index] : 'Unknown';
};


// WEBPACK FOOTER //
// src/components/MatchPlayer/teamColors.js